var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showHeader)?_c('the-header'):_vm._e(),_c('router-view'),_c('b-loading',{attrs:{"is-full-page":true,"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }